import { Recipe } from '@akin-home/recipes';
import { createMealModel, importRecipeToMeal } from '.';
import { Meal } from '../types';

export const createMealFromRecipe = (
  recipe: Recipe,
  mealData: Partial<Meal> & { start: Date; habitatID: string }
): Meal => importRecipeToMeal(recipe, createMealModel(mealData));
